var map = {
	"./activity.svg": 4589,
	"./add-square.svg": 24857,
	"./admin.svg": 50747,
	"./arrow-circle-down.svg": 41123,
	"./arrow-circle-up.svg": 10652,
	"./arrow-down.svg": 39786,
	"./arrow-left.svg": 48609,
	"./arrow-left2.svg": 81601,
	"./arrow-right-fill.svg": 19006,
	"./arrow-right.svg": 22188,
	"./arrow-up.svg": 92601,
	"./backsquare.svg": 69294,
	"./bale.svg": 93656,
	"./building-active.svg": 13153,
	"./building.svg": 2050,
	"./buyer.svg": 27183,
	"./calendar-primary.svg": 53385,
	"./calendar.svg": 82340,
	"./calendar2.svg": 16286,
	"./camera.svg": 71099,
	"./cancel-circle.svg": 54941,
	"./check-primary.svg": 15563,
	"./check.svg": 87486,
	"./chevron-down-select.svg": 14481,
	"./chevron-down.svg": 95420,
	"./chevron-up.svg": 6167,
	"./close-circle.svg": 51463,
	"./close.svg": 63866,
	"./cloud.svg": 49669,
	"./cloudconnection.svg": 63389,
	"./colorswatch.svg": 89587,
	"./copy.svg": 20509,
	"./counter.svg": 61214,
	"./courthouse.svg": 94425,
	"./crown-1.svg": 33945,
	"./crown-2.svg": 84650,
	"./crown-3.svg": 53467,
	"./crown.svg": 4399,
	"./csv.svg": 94398,
	"./danger.svg": 7179,
	"./danger_issue.svg": 48403,
	"./data-active.svg": 88885,
	"./data.svg": 82062,
	"./delete.svg": 96023,
	"./divider-mini.svg": 92691,
	"./divider.svg": 53109,
	"./download.svg": 87822,
	"./drag.svg": 41180,
	"./edit-square.svg": 58150,
	"./edit.svg": 57322,
	"./email.svg": 24426,
	"./eraser.svg": 90986,
	"./exit-full-screen.svg": 7101,
	"./exit-square.svg": 33458,
	"./export.svg": 38368,
	"./eye-disabled.svg": 90654,
	"./eye.svg": 45569,
	"./fatrows.svg": 33004,
	"./filter.svg": 71420,
	"./fingerprint.svg": 71494,
	"./fluent.svg": 82476,
	"./folder.svg": 64166,
	"./formatsquare.svg": 93806,
	"./full-screen.svg": 8794,
	"./fullscreen-b.svg": 49236,
	"./fullscreen.svg": 84149,
	"./gallery.svg": 57068,
	"./gallery_issue.svg": 52492,
	"./graph.svg": 27158,
	"./hardware.svg": 65730,
	"./hashtag.svg": 5698,
	"./hashtag2.svg": 7260,
	"./health.svg": 97064,
	"./history.svg": 27006,
	"./ic_down.svg": 3765,
	"./ic_down_primary.svg": 44850,
	"./import.svg": 97261,
	"./info-circle-primary.svg": 67766,
	"./info-circle.svg": 51891,
	"./leader-active.svg": 2008,
	"./leader.svg": 98421,
	"./location.svg": 69915,
	"./location_issue.svg": 19715,
	"./logo-mini.svg": 68981,
	"./logo-thumbnail.svg": 7572,
	"./logo.svg": 63935,
	"./logout.svg": 63180,
	"./magicpen.svg": 56652,
	"./maximize.svg": 13816,
	"./medal-star.svg": 3956,
	"./message-text.svg": 82889,
	"./more.svg": 75766,
	"./next.svg": 19053,
	"./note-active.svg": 2905,
	"./note.svg": 72074,
	"./notification-bing.svg": 93642,
	"./notification.svg": 23579,
	"./notificationstatus.svg": 15649,
	"./ocr.svg": 33574,
	"./operator.svg": 43886,
	"./option.svg": 57957,
	"./pause-circle.svg": 54993,
	"./pause.svg": 73028,
	"./pdf.svg": 87920,
	"./percentage.svg": 25070,
	"./pin.svg": 58259,
	"./play-circle.svg": 20921,
	"./play.svg": 10188,
	"./points.svg": 66719,
	"./previous.svg": 87909,
	"./print.svg": 37839,
	"./process-active.svg": 93040,
	"./process.svg": 45949,
	"./profile-circle.svg": 29786,
	"./profile2user-active.svg": 75839,
	"./profile2user.svg": 17636,
	"./qr-code.svg": 97451,
	"./quality.svg": 20317,
	"./rank.svg": 21364,
	"./ranking-active.svg": 68255,
	"./ranking.svg": 15268,
	"./refresh-circle.svg": 5200,
	"./refresh.svg": 40147,
	"./refresh_report.svg": 58088,
	"./reply.svg": 36378,
	"./report-fill.svg": 68370,
	"./report.svg": 90040,
	"./reports.svg": 36107,
	"./resume.svg": 72551,
	"./rotate.svg": 44203,
	"./scanbarcode.svg": 84439,
	"./search.svg": 98246,
	"./setting2.svg": 67412,
	"./shape-down.svg": 40026,
	"./shape-up.svg": 78313,
	"./share.svg": 12435,
	"./slack.svg": 13686,
	"./slash.svg": 51269,
	"./smartcar.svg": 7037,
	"./sort.svg": 28766,
	"./station.svg": 14202,
	"./stop.svg": 18678,
	"./supplier.svg": 29310,
	"./telegram.svg": 25039,
	"./tick-circle.svg": 10146,
	"./time_tracker.svg": 11720,
	"./timerstart.svg": 39179,
	"./timerstart1.svg": 23008,
	"./trash.svg": 33352,
	"./uncheck.svg": 90049,
	"./upload.svg": 38277,
	"./upper.svg": 21738,
	"./vector.svg": 34659,
	"./wallet.svg": 28729,
	"./warning.svg": 28330,
	"./weight.svg": 37702,
	"./zoomin.svg": 69862,
	"./zoomout.svg": 54913
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91980;